import styles from './index.module.scss'
import { useContext, useEffect, useMemo, useRef } from 'react';
import { GenerateContext } from '../../../hooks/GenerateContext';
import ResolutionSelection from '@view/compoents/ResolutionSelection/ResolutionSelection';
import { COMMODITY_SCENE_MODE } from '@utils/CONST'

const ResolutionSelectionWrap = () => {
    const {
        // 商品图输出比例
        outputRatio, setOutputRatio,
        // 商品图输出宽度
        outputWidth, setOutputWidth,
        // 商品图输出高度
        outputHeight, setOutputHeight,
        // 商品自定义场景配置
        refImgConfig,
    } = useContext(GenerateContext)
    
    // 分辨率选择
    const resolutionRef = useRef(null)

    // 商品图分辨率是否禁用
    const resolutionDisabled = useMemo(() => {
        if (!refImgConfig) return false
        const { refImgMode } = refImgConfig
        if (refImgMode == COMMODITY_SCENE_MODE.SAME_STYLE) {
            return true
        } else {
            return false
        }
    }, [refImgConfig])

    useEffect(() => {
        if (!refImgConfig) return
        const { refImgSize, refImgMode } = refImgConfig
        if (refImgMode == COMMODITY_SCENE_MODE.SAME_STYLE) {
            resolutionRef.current?.customSize(refImgSize.width, refImgSize.height)
        }
    }, [refImgConfig])

    return (
        <div className={styles.Container}>
            <div className={styles.Header}>
                <span>分辨率</span>
            </div>
            <div className={styles.Content}>
                <ResolutionSelection
                    ref={resolutionRef}
                    disabled={resolutionDisabled}
                    initImgRatio={outputRatio}
                    initImgWidth={outputWidth}
                    initImgHeight={outputHeight}
                    onChange={(w, h, ratio) => {
                        setOutputRatio(ratio)
                        setOutputWidth(w)
                        setOutputHeight(h)
                    }}
                />
            </div>
        </div>
    )
}


export default ResolutionSelectionWrap